import { render, staticRenderFns } from "./icon-header.vue?vue&type=template&id=240c7864&scoped=true"
import script from "./icon-header.vue?vue&type=script&lang=js"
export * from "./icon-header.vue?vue&type=script&lang=js"
import style0 from "./icon-header.vue?vue&type=style&index=0&id=240c7864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240c7864",
  null
  
)

export default component.exports